import { render, staticRenderFns } from "./ admin-password-reset-links.vue?vue&type=template&id=61aeab87&scoped=true&"
import script from "./ admin-password-reset-links.vue?vue&type=script&lang=js&"
export * from "./ admin-password-reset-links.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61aeab87",
  null
  
)

export default component.exports